<template>
  <div v-if="$route.params.query" class="modal fade hmodal-info" id="modalTableResult" tabindex="-1" role="dialog"  aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="color-line" style="display: block;"></div>
        <div class="modal-header">
          <h4 class="modal-title text-capitalize"><span style="font-weight: bold;">Company Table</span></h4>
        </div>
        <div class="modal-body">
          <table id="companyTable" class="table table-striped table-bordered table-hover ">
            <thead>
              <tr>
                <th>Organisation Name</th>
                <th>Status</th>
                <th>Category</th>
                <th>Source</th>
                <th>Incorp Date</th>
                <th>Country</th>
                <th>Website</th>
                <th>Turnover</th>
                <th>Number of Employees</th>
              </tr>
            </thead>
          </table>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import 'datatables.net-select-bs/css/select.bootstrap.min.css'
import 'datatables.net-select-bs/js/select.bootstrap.min'

import VueLadda from 'vue-ladda'
import Summernote from '../utils/Summernote'

export default {
  components: {
    VueLadda,
    Summernote
  },
  props: ['value', 'allCompanies'],
  name: 'CompanyTable',
  methods: {
  },
  data () {
    return {
      dataTable: null,
      companies: []
    }
  },
  mounted () {
    $('#modalTableResult').modal()
    $('#modalTableResult').on('hidden.bs.modal', (e) => {
      this.$emit('input', false)
    })

    this.allCompanies.forEach(company => {
      if (company.affiliation && company.docs[0]) {
        company.source_str = company.docs[0].sourceID === 11 ? 'Patent Applicant' : company.docs[0].sourceID === 28 ? 'Wikipedia Database' : company.docs[0].sourceID === 29 ? 'AI provider - Beta' : 'Companies Database'

        this.companies.push(company)
      }
    })

    this.dataTable = $('#companyTable').DataTable({
      pageLength: 50,
      responsive: true,
      processing: true,
      data: this.companies, // Passer les données directement
      columns: [
        { data: 'lastName', title: 'Organisation Name' },
        { data: 'affiliation.status_str', title: 'Status', render: function (data) { return data || 'n/a' } },
        { data: 'affiliation.category', title: 'Category', render: function (data) { return data || 'n/a' } },
        { data: 'source_str', title: 'Source' },
        { data: 'affiliation.incorporation_date', title: 'Incorp Date', render: function (data) { return data || 'n/a' } },
        { data: 'affiliation.country', title: 'Country' },
        {
          data: 'affiliation.url',
          title: 'Website',
          render: function (data) {
            return data ? `<a href="${data}" target="_blank">link</a>` : 'n/a'
          }
        },
        { data: 'affiliation.turnover', title: 'Turnover', render: function (data) { return data ? Math.round(data) + 'K €' : 'n/a' } },
        { data: 'affiliation.nb_employees', title: 'Number of Employees', render: function (data) { return data || 'n/a' } }
      ],
      dom: "<'row'<'col-sm-4'l><'col-sm-4 text-center'B><'col-sm-4'f>>t<'row'<'col-sm-3'i><'col-sm-6 text-center'p><'col-sm-3'>>",
      buttons: [
        { extend: 'copy', className: 'btn btn-xs btn-info btn-outline' },
        { extend: 'csv', text: 'Export as CSV', className: 'btn btn-xs btn-info btn-outline' }
      ],
      rowId: 'authorID',
      initComplete: () => {
      }
    })
  },
  beforeDestroy () {
    // Détruire l'instance DataTables quand le composant est détruit
    if (this.dataTable) {
      this.dataTable.destroy()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/CompanyTable.vue